import axios from 'axios';

export default {
  FETCH_QUOTES ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('common/getAllQuotes')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('quotes', JSON.stringify(payload));
                    commit('SET_QUOTES', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDQUOTE ({ commit }, quoteId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`common/getAllQuotes`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;

            console.log('payload', payload)
            let selectedQuote = payload.filter(x => {
              return x.quoteId.toString() === quoteId.toString()
            });

            console.log('found article', selectedQuote)
            commit('SET_SELECTED_QUOTE', selectedQuote[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_QUOTE({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add Quote payload : ", payload);
            payload.csvCorporationId = payload.csvCorporationId.toString()
            axios.post('common/insertQuotes', payload)
                .then((response) => {
                    console.log('ADD_QUOTE action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_QUOTE action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_QUOTE({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
          payload.csvCorporationId = payload.csvCorporationId.toString()
            commit('TOGGLE_LOADING', true);
            axios.put('/common/updateQuotes', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_QUOTE action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/quotes/actions.js